import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@app/core/configuration.service';
import { HttpBaseService } from '@app/core/http/http-base.service';
import { LocalizationService } from '@app/core/localization.service';
import { NotifyService } from '@app/core/notify.service';
import { ApiControllerEnum, EntityStateEnum } from '@app/shared/common/enums';
import { Observable } from 'rxjs/internal/Observable';
import { UserManagementFormItem } from '../models/user-profile-form-item';
import { UserForUserProfileItem, UserManagementListItem } from '../models/user-profile-list-item';
import { UserCvListItem } from '../models/user-cv-list-item';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService extends HttpBaseService {

  constructor(private http: HttpClient
    , private notifyServ: NotifyService
    , private localizationService: LocalizationService
    , private configService: ConfigurationService) {
    super(http, ApiControllerEnum.User, notifyServ, localizationService, configService);
  }

  getMemberListByFilter(filter: any): Observable<UserManagementListItem[]> {
    return this.post("getMemberListByFilter", filter, true);
  }

  getUserListForSelect(filter: any): Observable<UserManagementListItem[]> {
    return this.post("getUserListForSelect", filter, true);
  }
  
  getUserListForAccount(filter: any): Observable<UserManagementListItem[]> {
    return this.post("getUserListForAccount", filter, true);
  }

  getDataByFilter(filter: any): Observable<UserManagementListItem> {
    return this.post("GetDataByFilter", filter, true);
  }
  getUserCvFile(applicationId): Observable<UserCvListItem> {
    let params = new HttpParams();
    params = params.append('applicationId', applicationId);
    return this.getWithParams("GetUserCvFile", params);
  }
  // RESUME tab — analiz durumunu arka planda yoklamak için (global spinner tetiklemez).
  getUserCvFileSilent(applicationId): Observable<UserCvListItem> {
    return this.getWithoutSpinner(`GetUserCvFile?applicationId=${encodeURIComponent(applicationId)}`);
  }
  // RESUME tab — davetle gelen adayın mevcut CV'sini bu pozisyonun CV step kriterleriyle analiz ettir.
  triggerCvAnalysisForApplication(applicationId): Observable<string> {
    return this.post(`TriggerCvAnalysisForApplication?applicationId=${encodeURIComponent(applicationId)}`, null, true);
  }
  getUserCvFileByUserId(userId): Observable<UserCvListItem> {
    let params = new HttpParams();
    params = params.append('userId', userId);
    return this.getWithParams("GetUserCvFileByUserId", params);
  }
  // CVUser-only aday (Aday Havuzu'nda kayıtlı olmayan CV Scoring adayı) için CV dosyası.
  getCvUserCvFileByCvUserId(cvUserId): Observable<UserCvListItem> {
    let params = new HttpParams();
    params = params.append('cvUserId', cvUserId);
    return this.getWithParams("GetCvUserCvFileByCvUserId", params);
  }
}
